<div class="complex-filter-loading">
  <ftr-loader [isLoading]="true" [iconOnly]="true" [fullPage]="true"></ftr-loader>
</div>
